var src,srcset,wnw_windowWidth,wnw_windowHeight,critical2,critical3,cls_css,lazyBackground,lazyIframe,lazybg,lazybg2;

let allScriptRun = true;

document.addEventListener("DOMContentLoaded", function() {

	wnw_windowWidth = window.innerWidth;
	wnw_windowHeight = window.innerHeight;

    function addMultipleEventListener(element, eventNames, listener) {
        const events = eventNames.split(' ');
        const eventsLength = events.length;
        for (let i=0; i < eventsLength; i++) {
          element.addEventListener(events[i], listener, false);
        }
    }

    addMultipleEventListener(window, 'scroll mousemove touchstart', function(){
        initOptimization();
    });

});

function initOptimization() {
	lazyLoadCssFile() 
	if (allScriptRun) {
		allScriptRun = false;
		loadAll();
	}
}

function lazyLoadCssFile() {
	var linkTag = document.querySelectorAll("link[data-href]");
	for (i = 0; i < linkTag.length; i++) {
		var newLinkTag = document.createElement("link");
		newLinkTag.href = linkTag[i].getAttribute("data-href");
		newLinkTag.rel = "stylesheet";
		linkTag[i].parentNode.insertBefore(newLinkTag, linkTag[i]);
		delete linkTag[i].dataset.href;
		linkTag[i].parentNode.removeChild(linkTag[i]);
	}
}

function loadAll() {
	if(Shopify.designMode || window.location.href.indexOf("/cart") > -1 || window.location.href.indexOf("/checkout") > -1) {
		console.log("No-optimization");
	} else {
		console.log("Yes-optimization");

        setTimeout(() => {
            let customEventLoad = document.createEvent("Event");
            customEventLoad.initEvent("custom_event_load", true, true);
            window.document.dispatchEvent(customEventLoad);
        }, 500)
    
        setTimeout(() => {
            let customEventDOMContentLoaded = document.createEvent("Event");
            customEventDOMContentLoaded.initEvent("custom_event_DOMContentLoaded", true, true);
            window.document.dispatchEvent(customEventDOMContentLoaded);
        }, 6000)

	}

	lazyLoadScripts();

	setTimeout(function() {
		criticalCSS = document.querySelectorAll(".critical-css");
		criticalCSS.forEach(function(style) {
			style.remove();
		});
	}, 5000);

}

function lazyLoadScripts() {
	let scriptTags = document.querySelectorAll("script[type=script_lazyload]");
  
	if (scriptTags.length < 1) return;

	if (scriptTags[0].getAttribute("data-src") !== null) {
		let newScriptTAg = createScript(scriptTags[0]);
		newScriptTAg.onload = function() {
			lazyLoadScripts();
		};
		newScriptTAg.onerror = function() {
			lazyLoadScripts();
		};
	} else {
		inlineJavascript(scriptTags[0]);
		lazyLoadScripts();
	}
}

function createScript(scriptTag) {
	let newScriptTag = document.createElement("script");
	if (typeof(scriptTag.attributes) != "undefined") {
        const scriptAttributes = scriptTag.attributes;
        const scriptAttributesLength = scriptAttributes.length;
		for (let i = 0; i < scriptAttributesLength; i++) {
			let attribute = scriptAttributes[i];
			if (attribute.nodeName != "data-src" && attribute.nodeName != "type") {
				newScriptTag.setAttribute(attribute.nodeName, attribute.nodeValue);
			}
		}
	}
	newScriptTag.src = scriptTag.getAttribute("data-src");
	insertBefore(newScriptTag, scriptTag);
	delete scriptTag.dataset.src;
	delete scriptTag.type;
	scriptTag.parentNode.removeChild(scriptTag);
	return newScriptTag;
}

function inlineJavascript(script) {
	
	let newScriptTag = document.createElement("script");

	if (typeof(script.attributes) != "undefined") {
        const scriptAttributes = script.attributes;
        const scriptAttributesLength = scriptAttributes.length;
		for (let i = 0; i < scriptAttributesLength; i++) {
			let attribute = scriptAttributes[i];
			if(script.classList.contains('modulor_script')){
				if (attribute.nodeName === "type") {
					newScriptTag.setAttribute(attribute.nodeName, 'module');
				} else {
					newScriptTag.setAttribute(attribute.nodeName, attribute.nodeValue);
				}
			} else {
				if (attribute.nodeName != "type") {
					newScriptTag.setAttribute(attribute.nodeName, attribute.nodeValue);
				}
			}
		}
	}

	newScriptTag.innerHTML = script.innerHTML;
	insertBefore(newScriptTag, script);
	script.parentNode.removeChild(script);

}

function insertBefore(newNode, referenceNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

window.onload = function(){
	setTimeout(() => {
	  'Linux x86_64' != navigator.platform && initOptimization();
	})
}